import scrollLock from 'scroll-lock';

export default class Scrolllocking {
	constructor() {
		this.shouldLock = false;

		document.addEventListener('disable-scroll', event => {
			let scrollingElm = null;
			if(event.detail) {
				scrollingElm = event.detail.scrollingElm;
			}
			this.lock(scrollingElm);
		});

		document.addEventListener('enable-scroll', () => {
			this.unlock();
		});

		this.setScrollbarWidth();
	}

	setScrollbarWidth() {
		const scrollbarWidth = scrollLock.getPageScrollBarWidth();
		document.documentElement.style.setProperty('--scrollbarWidth', scrollbarWidth+'px');
	}

	lock(scrollingElm) {
        scrollLock.disablePageScroll(scrollingElm);
	}

	unlock() {
		scrollLock.clearQueueScrollLocks();
		scrollLock.enablePageScroll();
	}
}